import React, { useContext } from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { ThemeContext } from 'styled-components'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import {
  DataWrapper,
  Heading,
  DataCol,
  Logo,
  CompanyLink,
  Company,
  DataContainer,
  RatingContainer,
  ImgGptw,
  ContainerLink,
  ContainerAltaRevision,
} from './mixins'

// hooks
import { getCompanyURL } from '../../../../../../../hooks/get-company-url'

// constants
import { SITE_ID } from '../../../../../../../constants'
import features from '../../../../../../../constants/features-per-country'
import logoGPTW from '../../../../../../../assets/images/calificar-empresas/GPTW_Logo.svg'
import SeguirEmpresaLink from '../../FollowCompany'

const reviewEnabled = features[SITE_ID || 'BMAR'].reviews.enabled
const gptwEnabled = features[SITE_ID || 'BMAR'].gptw.enabled

const Component = ({ aviso, isZonaJobs, reviews }) => {
  const { isDesktop, isTabletLandscape } = useWindowSize()
  const isPortraitToLandscape = window.outerWidth >= 992 && window.outerWidth <= 1024
  const isDesktopOrLandscape = isDesktop || isTabletLandscape || isPortraitToLandscape
  const promedioEmpresa =
    reviewEnabled && reviews?.totalEmployeeReviews >= 3
      ? reviews.categories?.find(c => c.categoryId === 1)?.average
      : null
  const showGptw = gptwEnabled && aviso?.empresa.gptwUrl
  const settingsCompanyURL = getCompanyURL({ company: aviso?.empresa })
  const { colors } = useContext<{ colors }>(ThemeContext)
  const showAltaRevisionCvMismaLinea = isDesktopOrLandscape || isEmpty(aviso?.empresa.logoURL)

  const CustomCompanyLink = () => {
    if (aviso?.empresa.confidencial)
      return (
        <Text as="h3" size="sm" variant="gray60">
          Confidencial
        </Text>
      )
    if (aviso?.empresa.id == null || isZonaJobs)
      return (
        <Text as="h3" size="sm" variant="gray60">
          {aviso?.empresa.denominacion}
        </Text>
      )

    return (
      <CompanyLink {...settingsCompanyURL} linkoptions={{ variant: 'gray', native: false }}>
        <ContainerLink>
          <Icon name="icon-light-external-link" size="20" color={colors.grey60} />
          <Company>{aviso?.empresa.denominacion}</Company>
        </ContainerLink>
      </CompanyLink>
    )
  }

  const AltaRevisionCv = () => (
    <ContainerAltaRevision showAltaRevisionCvMismaLinea={showAltaRevisionCvMismaLinea}>
      <Icon name="icon-light-trending-up" color={colors.extra.normal} size="16" />
      <Text size="xs" fontWeight="semibold" variant="extra">
        Alta revisión de perfiles
      </Text>
    </ContainerAltaRevision>
  )

  return (
    <DataWrapper>
      {!isEmpty(aviso?.empresa.logoURL) && <Logo src={aviso?.empresa.logoURL} />}
      {showGptw && <ImgGptw src={logoGPTW} alt="logo GPTW" />}
      <DataCol>
        <Heading>
          <Text size="lg" fontWeight="semibold" variant="secondary" as="h1">
            {aviso?.titulo}
            {/* {!isEmpty(aviso?.aptoDiscapacitados) && <Icon name="icon-light-discapacity" size="20" color="gray" />} REVISARA DISEÑO MAS ADELANTE */}
          </Text>
        </Heading>

        <DataContainer>
          <CustomCompanyLink />
          {promedioEmpresa && !showGptw && (
            <RatingContainer>
              <Icon name="icon-bold-star" color="#FAB306" size="14" />
              <Text size="sm" fontWeight="bold" variant="gray60">
                {promedioEmpresa.toFixed(1)}
              </Text>
            </RatingContainer>
          )}
          {showAltaRevisionCvMismaLinea && aviso?.altaRevisionPerfiles && <AltaRevisionCv />}
          {isDesktopOrLandscape && <SeguirEmpresaLink aviso={aviso} />}
        </DataContainer>

        {!showAltaRevisionCvMismaLinea && aviso?.altaRevisionPerfiles && <AltaRevisionCv />}
      </DataCol>
    </DataWrapper>
  )
}

const mapStateToProps = ({ reviewStore }) => ({
  reviews: reviewStore.reviews,
})

export default connect(mapStateToProps)(Component)
